<template>
  <div>
    <div
      :class="[gameType === 'MW' ? 'modal modal-game_memory_wizard' : gameType === 'ODD' ? 'modal modal-game_odd_object': 'modal modal-game_spot_difference', isIos ? 'ui_desc_ios' : '']"
      :id="[gameType === 'MW' ? 'modal-game_memory_wizard' : gameType === 'ODD' ? 'modal-game_odd_object': 'modal-game_spot_difference']">
      <div class="modal__content lost_game_modal">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header modal_ti_header">
          <div class="row gamepage_header">
            <img v-if="gameType === 'MW'" class="gamepage_logo " src="static/images/logo-memory-wizard.png"/>
            <img v-if="gameType === 'ODD'" class="gamepage_logo " src="static/images/logo-odd-object.png"/>
            <img v-if="gameType === 'SD'" class="gamepage_logo " src="static/images/logo-spot-difference.png"/>
            <h1 v-if="gameType === 'MW'">{{ getTranslations.home_game_memory_wizard }}</h1>
            <h1 v-if="gameType === 'ODD'">{{ getTranslations.home_game_odd_game }}</h1>
            <h1 v-if="gameType === 'SD'">{{ getTranslations.home_game_sd_game }}</h1>
            <p>{{ getTranslations.home_modals_offtime_oh_no }}</p>
            <p>{{ getTranslations.home_modals_offtime_time_is_up }}</p>
          </div>
        </div>
        <div class="modal__body">
          <img class="modal_result" src="static/images/postgame-time-up.png"/>
          <p class="cta_support">{{ getTranslations.home_modals_offtime_do_not_give_up }}</p>
          <a class="ti_btn--green modal_cta" style="cursor:pointer"
             @click.prevent="playGameMethodWithDifferentImpl()">{{ getTranslations.home_modals_offtime_try_again }}</a>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex';
import NewGameMixin from '@/common/mixins/home';
import GameIntro from './GameIntro';
import modals from '../../../common/modals';

export default {
  name: 'time-is-up',
  mixins: [NewGameMixin],
  data() {
    return {
      isIos: false,
    };
  },
  created() {
    console.log('in TimeIsUp created hook:');
    this.isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  },
  methods: {
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapMutations('game', [
      'resetGameState',
      'resetPrizeData',
    ]),
    playGameMethodWithDifferentImpl() {
      this.getUserLoginDetails().then(() => {
        if (this.isEligibleToPlay(this.gameType)) {
          this.playGame(this.gameType);
        } else {
          this.storeModalForHomePage(GameIntro);
          modals.showHideModalForGameNotificationPage(this);
        }
      });
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('game', [
      'gameType',
      'gameID',
      'playersDetails',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/TimeIsUp.vue